// extracted by mini-css-extract-plugin
export default {"card-dimension":"StillNotConvinced_card-dimension__7lmH-"};